var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "fixed-relation" }, [
      _c("div", { staticClass: "tencent-map", attrs: { id: "tencent-map" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }